import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhysicalFitnessRoutingModule } from './physical-fitness-routing.module';
import { FormsModule } from '@angular/forms';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CrudComponent } from './crud/crud.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzCardModule } from 'ng-zorro-antd/card';
import { ManageComponent } from './manage/manage.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { FitnessLogsComponent } from './fitness-logs/fitness-logs.component';

@NgModule({
  declarations: [
    CrudComponent,
    ManageComponent,
    FitnessLogsComponent
  ],
  imports: [
    CommonModule,
    PhysicalFitnessRoutingModule,
    FormsModule,
    NzSpinModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzSwitchModule,
    NzAutocompleteModule,
    NzCardModule,
    NzTableModule,
    NzIconModule,
    NzGridModule,
    NzDropDownModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzTagModule
  ]
})
export class PhysicalFitnessModule { }
